/**
 * Internal QA hostnames bypass tenant maintenance mode on all user frontends.
 * Keep business-services tenant-management and user-auth internalStagingHost.js in sync.
 */
export const INTERNAL_STAGING_HOST_PREFIXES = ['staging', 'mepro', 'new1', 'dev', 'preview', 'test', 'qa'] as const

export type InternalStagingHostPrefix = (typeof INTERNAL_STAGING_HOST_PREFIXES)[number]

export function getHostnameFirstLabel(hostname = ''): string {
  const host = String(hostname || '').trim().toLowerCase()
  if (!host) return ''
  return host.split('.')[0] || ''
}

export function isInternalStagingHostname(hostname = typeof window !== 'undefined' ? window.location.hostname : ''): boolean {
  const host = String(hostname || '').trim().toLowerCase()
  if (!host || host === 'localhost' || host === '127.0.0.1') return false
  return (INTERNAL_STAGING_HOST_PREFIXES as readonly string[]).includes(getHostnameFirstLabel(host))
}

export function resolveInternalStagingBaseDomain(hostname = ''): string | null {
  const host = String(hostname || '').trim().toLowerCase().replace(/^www\./, '')
  const parts = host.split('.')
  if (parts.length < 3) return null
  if (!(INTERNAL_STAGING_HOST_PREFIXES as readonly string[]).includes(parts[0])) return null
  return parts.slice(1).join('.')
}
